// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__ATZwo","animEnd":"Hero_animEnd__UEMxt","desc":"Hero_desc__DRxSd","pageAnim":"Hero_pageAnim___trQ9","cta":"Hero_cta__2RR8r","in-view":"Hero_in-view__sVDW3"};